<ng-template [ngIf]="config">
  <div class="form-group">
      <ion-label class="form-label">
        {{config.label | multiLang}}
        <ng-template [ngIf]="config.required">
          <ion-text color="danger">*</ion-text>
        </ng-template>
      </ion-label>
      <ion-radio-group  (ionChange)="radioGroupChange($event)">
        <ion-list>
          <div *ngFor="let option of options">
            <ion-item>
              <ion-radio  [value]="option.value" slot="start"></ion-radio>
              <ion-label>{{option.label | multiLang }}</ion-label>
            </ion-item>
          </div>
        </ion-list>
      </ion-radio-group>  

      <div *ngIf="control.invalid">
        <ion-text color="danger" class="m-b-5">
          <span class="f-12 m-l-20" aria-live="assertive">{{requiredErrorMessage}}</span>
        </ion-text>
      </div>

  </div>

</ng-template>